module.exports = {"id":"186627","name":"Mario Balotelli","rating":"83","photo":"./data/images/photos/3/186627.png","club":{"name":"OGC Nice","logo":"./data/images/clubs/OGCNice.png"},"positions":["BU"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MarioBalotelli0.json
// module id = 2776
// module chunks = 0